import React from 'react';
import Slider from 'react-slick';
import { Icon } from 'antd';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import icon from '../../../images/fileicon.png';
import 'react-viewer/dist/index.css';
import Viewer from 'react-viewer';
import 'react-viewer/dist/index.css';
const moment = require('moment');

class ActivityGallery extends React.Component {
  constructor() {
    super();
    this.state = {
      imagePreview: false,
      image: '',
      slide: null
    };
  }

  openImg = img => {
    this.setState({ image: img, imagePreview: true });
  };

  componentDidMount = () => {
    this.setState({ slide: this.props.slide });
  };

  render() {
    const { color, t, projectCompleted } = this.props;

    let settings = {
      dots: false,
      infinite: false,
      autoplay: false,
      slidesToShow: 1,
      slidesToScroll: 1,
      className: 'center',
      centerMode: true,
      useCSS: true,
      useTransform: false,
      lazyLoad: true,
      initialSlide: this.props.slide,
      adaptiveHeight: false
    };

    const styles = {
      box: {
        backgroundColor: 'white',
        boxShadow: '0 2px 8px 0 rgba(0,0,0,0.16)',
        borderRadius: 10,
        padding: 20,
        marginBottom: 10,
        position: 'relative',
        width: '700px',
        margin: '0 auto'
      },
      title: {
        fontFamily: 'Arial Rounded MT Bold',
        color: color,
        fontSize: 16,
        marginBottom: 0
      },
      entry: {
        fontFamily: 'Helvetica Neue',
        color: color,
        fontSize: 16,
        marginBottom: 20
      },
      edit: {
        width: 'max-content',
        padding: '0px 20px',
        backgroundColor: color,
        borderRadius: 10,
        color: 'white',
        fontFamily: 'Arial Rounded MT Bold',
        fontSize: 12,
        position: 'absolute',
        right: 30,
        top: 30,
        cursor: 'pointer'
      },
      fileIcon: {
        width: 40,
        borderRadius: '50%',
        backgroundColor: color,
        border: '1px solid white',
        padding: 7,
        cursor: 'pointer',
        marginRight: 20
      },
      attachment: {
        display: 'flex',
        alignItems: 'top'
      },
      pageNum: {
        width: 'max-content',
        padding: '6px 20px 0px 20px',
        backgroundColor: this.props.color,
        borderRadius: 20,
        color: 'white',
        fontSize: 14,
        margin: '0 auto',
        marginTop: 20
      }
    };

    const imageFormats = ['JPG', 'jpg', 'PNG', 'png'];

    return (
      <div>
        <Slider
          {...settings}
          beforeChange={(oldIndex, newIndex) =>
            this.setState({ slide: newIndex })
          }>
          {this.props.data &&
            this.props.data.map((activity, index) => (
              <div style={{ color: 'red' }}>
                <div style={styles.box}>
                  <h3 style={styles.title}>{t('Title Activity')}</h3>
                  <p style={styles.entry}>{activity[1].title}</p>
                  <h3 style={styles.title}>{t('Notes')}</h3>
                  <p style={styles.entry}>{activity[1].notes}</p>
                  {!projectCompleted && (
                    <div
                      onClick={() => this.props.editActivity(activity[0])}
                      style={styles.edit}>
                      <Icon
                        type="edit"
                        style={{
                          fontSize: 12,
                          color: 'white',
                          position: 'relative',
                          bottom: 2,
                          marginRight: 10
                        }}
                      />{' '}
                      Edit
                    </div>
                  )}
                  {Array.isArray(activity[1].downloadURL) && (
                    <div>
                      <h3 style={styles.title}>{t('Files Attached')}</h3>
                      <div style={styles.attachment}>
                        <div>
                          <img style={styles.fileIcon} src={icon} />
                        </div>
                        <div>
                          {activity[1].downloadURL.map(
                            attachment =>
                              attachment.name.split('.').slice(-1)[0] &&
                              imageFormats.includes(
                                attachment.name.split('.').slice(-1)[0]
                              ) ? (
                                <p
                                  onClick={() =>
                                    this.setState({
                                      image: attachment.url,
                                      imagePreview: true
                                    })
                                  }
                                  style={styles.entry}>
                                  {attachment.name}
                                </p>
                              ) : (
                                <a href={attachment.url} target="_blank">
                                  <p style={styles.entry}>{attachment.name}</p>
                                </a>
                              )
                          )}
                        </div>
                      </div>
                    </div>
                  )}
                </div>
                <div style={styles.pageNum}>
                  {index + 1} / {this.props.data.length}
                </div>
              </div>
            ))}
        </Slider>
        <Viewer
          visible={this.state.imagePreview}
          onClose={() => {
            this.setState({ imagePreview: false });
          }}
          images={[{ src: this.state.image, alt: '' }]}
          attribute={false}
          drag={false}
          zoomable={false}
          rotatable={false}
          scalable={false}
          changable={false}
          noNavbar={true}
          noToolbar={true}
          noFooter={true}
        />
      </div>
    );
  }
}

export default ActivityGallery;



// WEBPACK FOOTER //
// ./src/containers/StudentApp/components/ActivityGallery.js